import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            carousel: {
                itemsPerSlide: 5,
                activeSlideIndex: 0
            }
        };
    },

    computed: {
        ...mapGetters({
            getSystemById: 'moduleCourse/getSystemById',
            currentLocale: 'moduleApp/locale'
        }),

        system() {
            return this.getSystemById(this.$route.params.systemId);
        },

        journey() {
            return this.system.journeys.find(
                journey => journey.name === this.routeStringToName(this.$route.params.journeyName)
            );
        },

        step() {
            return this.journey.steps.find(step => step.name === this.routeStringToName(this.$route.params.stepName));
        },

        stepItems: {
            get: function () {
                return this.step.items;
            },
            set: function (newArr) {
                this.step.items = newArr;
            }
        },

        slideItems() {
            const { itemsPerSlide, activeSlideIndex } = this.carousel;

            return this.stepItems.slice(activeSlideIndex * itemsPerSlide, itemsPerSlide * (activeSlideIndex + 1));
        },

        carouselSlidesCount() {
            return Math.ceil(this.stepItems.length / this.carousel.itemsPerSlide);
        },

        percentageProgress() {
            return Math.ceil((this.matchedItemsCount / this.matchBoxNumbers.length) * 100);
        }
    },

    methods: {
        routeStringToName(string) {
            const firstLetterUppercase = string.charAt(0).toUpperCase();

            return firstLetterUppercase + string.slice(1).split('-').join(' ');
        },

        urlifyString(string) {
            return string.toLowerCase().split(' ').join('-');
        },

        createImagePath(imageName) {
            // we can't have line breaks in src string thats why disable pretttier for this line
            // prettier-ignore
            return require(`@/assets/images/system-images/${this.urlifyString(this.system.name)}/${this.urlifyString(this.journey.name)}/${this.urlifyString(this.step.name)}/${imageName}.jpg`);
        },

        shuffleItemsInArray(array) {
            array.sort(() => 0.5 - Math.random());
        }
    }
};
